export const constants = {
  patientsCategories: [
    { label: "All", value: "" },
    { label: "Patients", value: "patient" },
    { label: "Deliveries", value: "delivery" },
    { label: "Dispensaries", value: "dispensary" },
    { label: "Brands", value: "brand" },
    { label: "Doctors", value: "doctor" },
    { label: "Drivers", value: "driver" },
    { label: "Storekeepers", value: "storekeeper" },
  ],
};
